import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import axios from "axios";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import Box from "@mui/material/Box";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Password } from "primereact/password";
import Grid from "@mui/material/Grid";
import { Dropdown } from "primereact/dropdown";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

const apiUrl = process.env.REACT_APP_API_URL;

export function Chauffeurs() {
    const [chauffeurs, setChauffeurs] = useState([]);
     const [selectedChauffeurs, setSelectedChauffeurs] = useState(null);
        const [passwordVisibility, setPasswordVisibility] = useState({});
        const toast = useRef(null);
        
        const [visible, setVisible] = useState(false);
        const [modifVisible, setVisibleModif] = useState(false);
    
        const [identifiant, setIdentifiant] = useState("");
        const [motDePasse, setMotDePasse] = useState("");
        const [tel,setTel] = useState("");
        const [email,setEmail] = useState("");

        const [traitement, setTraitement] = useState("");
    
        const [identifiantNonModif,setIdentifiantNonModif] = useState("");


         useEffect(() => {
                axios.get(`${apiUrl}/IHM/api/chauffeurs.php?AllChauffeurs`)
                    .then(response => {
                        setChauffeurs(response.data);
                    })
                    .catch(error => {
                        console.error("Erreur lors du chargement des factures :", error);
                    });
            }, [apiUrl]);



             const onModifIc = (idChauffeur,chauffeur, motDePasse, tel,email) => {
               
               setIdentifiantNonModif(idChauffeur);
               setIdentifiant(chauffeur);
               setMotDePasse(motDePasse);
               setTel(tel);
               setEmail(email);
               setVisibleModif(true);
             };

             const onDeleteIc = async (idChauffeur, motDePasse, traitement) => {
               if (window.confirm(`Voulez vous supprimer ${idChauffeur}?`)) {
                 try {
                   await axios
                     .get(
                       `${apiUrl}IHM/api/chauffeurs.php?suppression&identifiant=${idChauffeur}`
                     )
                     .then((response) => {
                       if (response.data) {
                         toast.current.show({
                           severity: "success",
                           summary: `Réussi`,
                           detail: "Suppression de l'utilisateur réussi",
                           life: 3500,
                         });
                         setVisible(false);
                         window.location.reload();
                       } else {
                         toast.current.show({
                           severity: "error",
                           summary: `échec`,
                           detail: "erreur sur la suppression",
                           life: 3500,
                         });
                       }
                     });
                 } catch (error) {
                   toast.current.show({
                     severity: "error",
                     summary: `Erreur`,
                     detail:
                       "Une erreur est survenue lors de la modification de l'utilisateur",
                     life: 3500,
                   });
                   console.error(
                     "Erreur dans la modification de l'utilisateur :",
                     error
                   );
                 }
               } else {
                 setIdentifiant("");
                 setMotDePasse("");
                 setTraitement("");
               }
             };


             const handleSubmit = async (e) => {
               const data = {
                 identifiant: identifiant,
                 motDePasse: motDePasse,
                 tel: tel,
                 email: email
               };
               try {
                 await axios
                   .put(`${apiUrl}IHM/api/chauffeurs.php`, data)
                   .then((response) => {
                     if (response.data) {
                       toast.current.show({
                         severity: "success",
                         summary: `Réussi`,
                         detail: "Ajout de l'utilisateur réussi",
                         life: 3500,
                       });
                       setVisible(false);
                       window.location.reload();
                     } else {
                       toast.current.show({
                         severity: "error",
                         summary: `échec`,
                         detail: "erreur sur la création",
                         life: 3500,
                       });
                     }
                   });
               } catch {}
             };

             const handelSubmitModif = async (e) => {
               try {
                 await axios
                   .get(
                     `${apiUrl}IHM/api/chauffeurs.php?traitement=${identifiantNonModif}&identifiant=${identifiant}&motDePasse=${motDePasse}&tel=${tel}&email=${email}`
                   )
                   .then((response) => {
                     if (response.data) {
                       toast.current.show({
                         severity: "success",
                         summary: `Réussi`,
                         detail: "Modification de l'utilisateur réussi",
                         life: 3500,
                       });
                       setVisible(false);

                       setIdentifiant("");
                       setIdentifiantNonModif("");
                       setMotDePasse("");
                       setTraitement("");

                       window.location.reload();
                     } else {
                       toast.current.show({
                         severity: "error",
                         summary: `échec`,
                         detail: "erreur sur la modification",
                         life: 3500,
                       });
                     }
                   });
               } catch (error) {
                 toast.current.show({
                   severity: "error",
                   summary: `Erreur`,
                   detail:
                     "Une erreur est survenue lors de la modification de l'utilisateur",
                   life: 3500,
                 });
                 console.error(
                   "Erreur dans la modification de l'utilisateur :",
                   error
                 );
               }
             };

             const togglePasswordVisibility = (rowIndex) => {
               setPasswordVisibility((prevState) => ({
                 ...prevState,
                 [rowIndex]: !prevState[rowIndex],
               }));
             };
             function hex2bin(hex) {
               const bytes = [];

               for (let i = 0; i < hex.length; i += 2) {
                 bytes.push(parseInt(hex.substr(i, 2), 16));
               }

               return new TextDecoder("utf-8").decode(new Uint8Array(bytes));
             }

const passwordBodyTemplate = (rowData, { rowIndex }) => {
  return (
    <div>
      <span>
        {passwordVisibility[rowIndex] ? hex2bin(rowData.password) : "••••••"}
      </span>
      <i
        className={`pi ${
          passwordVisibility[rowIndex] ? "pi-eye-slash" : "pi-eye"
        }`}
        onClick={() => togglePasswordVisibility(rowIndex)}
        style={{
          cursor: "pointer",
          fontSize: "15px",
          marginLeft: "10px",
        }}
      ></i>
    </div>
  );
};


    const enteteTableau3 = () => {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3>Chauffeurs de navettes</h3>
          <Button
            label="Chauffeurs"
            onClick={() => {
              setIdentifiant("");
              setMotDePasse("");
              setVisible(true);
            }}
            icon="pi pi-plus"
            severity="success"
          />
        </div>
      );
    };

if (localStorage.getItem("us") === 'admin' || localStorage.getItem("us") === 'dev') {

    return (
      <>
        <Toast ref={toast} position="top-right" />

        <Sidebar
          visible={visible}
          header="Nouveau chauffeur"
          position="right"
          onHide={() => setVisible(false)}
        >
          <div>
            <InputText
              placeholder="Chauffeur"
              className="p-inputtext-lg"
              onChange={(e) => setIdentifiant(e.target.value)}
              value={identifiant}
            />
            <br />
            <br />
            <Password
              placeholder="Mot de passe"
              className="p-inputtext-lg"
              onChange={(e) => setMotDePasse(e.target.value)}
              value={motDePasse}
              toggleMask
            />
            <br />
            <br />
            <InputText
              placeholder="Téléphone"
              className="p-inputtext-lg"
              onChange={(e) => setTel(e.target.value)}
              value={tel}
            />
            <br />
            <br />

            <InputText
              placeholder="Email"
              className="p-inputtext-lg"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <br />
            <br />

            <Button
              label="Enregistrer"
              icon="pi pi-save"
              severity="info"
              className="w-full"
              onClick={() => {
                handleSubmit();
              }}
            />
          </div>
        </Sidebar>

        <Sidebar
        header="Modification de chauffeur"
          visible={modifVisible}
          position="right"
          onHide={() => setVisibleModif(false)}
        >
          <div>
            <InputText
              placeholder="Identifiant"
              className="p-inputtext-lg"
              onChange={(e) => setIdentifiant(e.target.value)}
              value={identifiant}
            />
            <br />
            <br />
            <Password
              placeholder="Mot de passe"
              className="p-inputtext-lg"
              onChange={(e) => setMotDePasse(e.target.value)}
              value={motDePasse}
              toggleMask
            />
            <br />
            <br />
             <InputText
              placeholder="Identifiant"
              className="p-inputtext-lg"
              onChange={(e) => setTel(e.target.value)}
              value={tel}
            />
            <br />
            <br />
             <InputText
              placeholder="Identifiant"
              className="p-inputtext-lg"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />

            <br />
            <br />

            <Button
              label="Modifier"
              icon="pi pi-save"
              severity="info"
              className="w-full bg-[#2fcd71] hover:bg-[#2fcd71]"
              onClick={() => {
                handelSubmitModif();
              }}
            />
          </div>
        </Sidebar>

        <DataTable
          value={chauffeurs}
          rows={25}
          size={"small"}
          tableStyle={{ minWidth: "50rem" }}
          header={enteteTableau3}
          dataKey="idUser"
          rowsPerPageOptions={[5, 8, 10, 25, 50]}
          paginator
          scrollable
          scrollDirection="horizontal"
          paginatorTemplate={
            "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
          }
          emptyMessage="Aucun chauffeur pour le moment"
          paginatorRight={
            <span style={{ margin: "10px", fontWeight: "bold" }}>
              Résultats : {chauffeurs.length}
            </span>
          }
        >
          <Column field="nomPrenom" header="Chauffeur" style={{ width: "30%" }}/>

          <Column
            field="password"
            header="Mot de passe"
            style={{ width: "30%" }}
            body={passwordBodyTemplate}
          />

          <Column field="tel" header="Téléphone" style={{ width: "30%" }} />

          <Column field="email" header="Email" style={{ width: "30%" }} />

          <Column
            header="Actions"
            style={{ textAlign: "center", width: "100px" }}
            body={(rowData) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "5px",
                }}
              >
                <Button
                  icon="pi pi-pencil"
                  severity="success"
                  size="small"
                  onClick={() => {
                    onModifIc(
                    rowData.idChauffeur,
                      rowData.nomPrenom,
                      hex2bin(rowData.password),
                       rowData.tel,
                       rowData.email
                
                    );
                    
                  }}
                />

                <Button
                  icon="pi pi-trash"
                  severity="danger"
                  size="small"
                  onClick={() => {
                    onDeleteIc(
                      rowData.idChauffeur,
                      hex2bin(rowData.password),
                      "suppression"
                    );
                  }}
                />
              </div>
            )}
          />
        </DataTable>
      </>
    );
}
else {
        return (
            <div className="p-d-flex p-jc-center p-ai-center" style={{ height: '100vh' }}>
                <Card title="Page Non Disponible" className="p-shadow-3">
                    <div className="p-text-center">
                        <p>Nous sommes désolés, mais la page que vous cherchez n'est pas disponible.</p>
                    </div>
                </Card>
            </div>
        );

    }

  
}
